import React from 'react';
import { Button } from './Button';
export const IntroSection = () => {
  const checkoutUrl = 'https://www.neurotoned.com/offers/sPjut2p7/checkout?coupon_code=21OFFNEUROPROGRAMNEWMEMBERS';
  return <section className="bg-teal-800 bg-opacity-90 text-white py-16" data-id="element-199">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-200">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-201">
          Introducing: The Neurotoned 30-Day Nervous System Reset
        </h2>
        <div className="mb-8 max-w-2xl mx-auto" data-id="element-202">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hmVNVLBcAGtfDNtJ9ANiKv/2058de-c04a-327d-23ba-aa864c213b35_Self-Acupressure_Energy_Balance_for_a_Healthy_Nervous_System_Option_2_1_.jpg" alt="Self-acupressure illustration" className="w-full rounded-lg shadow-xl" data-id="element-203" />
        </div>
        <div className="mb-10 space-y-6" data-id="element-204">
          <p className="text-xl font-bold text-center" data-id="element-205">
            Finally, a somatic program built for people who already know the
            problem... and are ready for a real solution.
          </p>
          <p className="text-center text-lg" data-id="element-206">
            Normally $70 — Today just <span className="font-bold" data-id="element-207">$29</span> for
            lifetime access.
          </p>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-208">
            <p className="mb-4" data-id="element-209">You've tried:</p>
            <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-210">
              <li data-id="element-211">Polyvagal podcasts</li>
              <li data-id="element-212">Instagram nervous system tips</li>
              <li data-id="element-213">Grounding exercises that help... a little</li>
            </ul>
            <p className="mb-4" data-id="element-214">
              But you haven't yet found a structure that actually rewires your
              system.
            </p>
            <p className="mb-4" data-id="element-215">
              Not just something that calms you down in the moment.
            </p>
            <p className="mb-4" data-id="element-216">
              But something that <em data-id="element-217">resets you</em> at the root.
            </p>
          </div>
          <div data-id="element-218">
            <p className="mb-4" data-id="element-219">
              Neurotoned is a 30-day trauma-informed experience for people who
              are:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-220">
              <li data-id="element-221">Burned out from self-guided somatic guesses</li>
              <li data-id="element-222">
                Sick of sorting through 90-second reels to heal lifelong
                patterns
              </li>
              <li data-id="element-223">
                Ready for a <strong data-id="element-224">cohesive, body-led</strong> nervous system
                healing framework
              </li>
            </ul>
            <p className="font-bold text-lg" data-id="element-225">And it works.</p>
          </div>
        </div>
        <div className="flex justify-center" data-id="element-226">
          <Button link={checkoutUrl} data-id="element-227">Start the Reset ➔</Button>
        </div>
      </div>
    </section>;
};